<div class="__not__found">
  <div class="__text">
    <h5>Hey there!</h5>
    <p>Hold tight, we are getting things ready for you...</p>
  </div>
</div>
